import styled from "styled-components";

export const Container = styled.a`
  width: 50%;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  justify-content: center;
  background-color: #ff8308;
  text-decoration: none;
  background-repeat: no-repeat;
  background-size: cover;

  > span {
    font-family: var(--multi-bold);
    color: var(--white);
    font-size: 16px;
    font-weight: var(--extraBold);
  }

  &:hover {
    background-color: transparent;
    border: 1px solid #ff8308;
    > span {
      color: #ff8308;
    }
  }
`;
